import * as React from "react";
import * as Palette from "../../../../palette";
import assert from "assert";
import * as _ from "lodash";
import { pluralize } from "../../../../core/helpers";
import { inputs } from "../models/attribute-inputs";
import { schema } from "../models/attribute-schema";
import { validate } from "../models/attribute-validator";
import { buildInput } from "./helpers";
import { PropertiesTitle } from "./properties-title";
import { PageLayout } from "../../../../palette/layout/page-layout";

export interface FormStepProps {
  query: string;
  servicesCount: number;
  data: FormStepData;
  setStepData: SetFormStepData;
}

export type Values = { [key: string]: any };
export type Errors = { [key: string]: string[] };
export interface FormStepData {
  values: Values;
  errors: Errors;
}
export const initialFormStepData: FormStepData = {
  values: {},
  errors: {}
};

export type SetFormStepData = (data: Partial<FormStepData>) => void;

export class FormStep extends React.Component<FormStepProps, {}> {
  render() {
    const updatedCount = Object.keys(this.props.data.values).length;

    const { values, errors } = this.props.data;
    const updatedFieldNames = inputs
      .filter(input => input.id in values)
      .map(({ title }) => title);
    return (
      <PageLayout title="Change Attributes">
        {updatedCount > 0 ? (
          <p>
            <Palette.BoldSpan>
              <code>{updatedFieldNames.join(", ")}</code>
            </Palette.BoldSpan>
            &nbsp;
            {pluralize(updatedCount, "field is", "fields are")} going to be
            updated on&nbsp;
            <Palette.NoWrapWhiteSpace>
              {this.props.servicesCount}{" "}
              {pluralize(this.props.servicesCount, "service", "services")}
            </Palette.NoWrapWhiteSpace>
          </p>
        ) : (
          <p>Select fields to update</p>
        )}

        <Palette.Table
          className="bulk-edit-form"
          format={["small", "small", "big"]}
          cells={inputs.map(input => {
            const isChecked = input.id in values;
            const fieldErrors = errors[input.id] || [];
            return [
              <input
                key={"" + isChecked}
                type="checkbox"
                checked={isChecked}
                onChange={this.onCheck(input.id)}
              />,
              <PropertiesTitle>{input.title}</PropertiesTitle>,
              isChecked ? (
                buildInput(
                  input,
                  values[input.id],
                  fieldErrors,
                  this.onFieldChange,
                  false
                )
              ) : (
                <span />
              )
            ];
          })}
        />
      </PageLayout>
    );
  }

  onCheck = (id: string) => (e: any) => {
    e.preventDefault();
    const values = { ...this.props.data.values };
    const errors = { ...this.props.data.errors };
    if (id in values) {
      delete values[id];
    } else {
      assert(id in schema.properties, "attribute not found in schema");
      values[id] = (schema.properties as any)[id].default;
    }
    delete errors[id];
    this.props.setStepData({ values, errors });
  };

  onFieldChange = (id: string, value: any) => {
    const values = { ...this.props.data.values };
    values[id] = value;
    this.props.setStepData({ values });
    this.delayedValidation(id);
  };

  delayedValidation = _.debounce((id: string) => {
    const { values } = this.props.data;
    const errors = { ...this.props.data.errors };
    if (!(id in values)) {
      // Field has been unchecked
      return;
    }
    const fieldErrors = validate({ [id]: values[id] });
    if (fieldErrors.length > 0) {
      errors[id] = fieldErrors;
    } else {
      delete errors[id];
    }
    this.props.setStepData({ errors });
  }, 500);
}
